// extracted by mini-css-extract-plugin
module.exports = {"svgSprite":"_1cBaD","regular":"_1TQrl","large":"_2CFk9"};